import { RestError } from '@azure/core-http';
import { useImmer } from 'use-immer';
import { useMutationResendInvite } from '../../../team.queries';
import { ResendInviteModalProps } from './resend-invite.modal';
import { castDraft } from 'immer';

export interface ResendInviteActionProps extends ResendInviteModalProps {
  invitationID: string;
}

export interface ResendInviteActionState {
  error?: RestError;
  loading: boolean;
}

export interface ResendInviteActionHandlers {
  onCancelIntent(): void;
  onConfirmResendInvite(): void;
}

const initialState: ResendInviteActionState = {
  loading: false
};

export function useResendInviteAction({ invitationID, projectID, onClose, onSuccess }: ResendInviteActionProps) {
  const [state, setState] = useImmer(initialState);
  const resendInviteMutation = useMutationResendInvite();

  const handlers: ResendInviteActionHandlers = {
    onCancelIntent() {
      onClose();
    },
    onConfirmResendInvite() {
      setState((draft) => {
        draft.loading = true;
      });
      resendInviteMutation.mutate(
        { invitationID, projectID },
        {
          onSuccess() {
            onSuccess();
          },
          onError(error) {
            setState((draft) => {
              draft.loading = false;
              draft.error = castDraft(error as RestError);
            });
          }
        }
      );
    }
  };

  return [state, handlers] as const;
}
